import { jsx as _jsx } from "react/jsx-runtime";
import T from '../../Utils/Locale';
import PropTypes from 'prop-types';
const TicketLink = ({ redirectUrl }) => (_jsx("a", Object.assign({ href: redirectUrl }, { children: _jsx("i", { className: 'toolbar-icon toolbar-icon__active fa fa-question', "aria-hidden": 'true', title: T('tickets.title') }) })));
TicketLink.propTypes = { redirectUrl: PropTypes.string };
export default TicketLink;
